export enum ProductType {
  LineSkip = 0,
  Drink = 1,
  Cover = 2,
  Bundle = 3,
  Other = 4, 
  Menu = 5,
  Ticket = 6
}



